import axios from '../utils/axios';
import config from '../utils/config';

const REQUEST_REPORT_URL = config.get('insights_api','request_report');
const REQUEST_NEW_REPORT_URL = config.get('insights_api','request_new_report');
const ADD_EXISTING_REPORT_URL = config.get('insights_api','add_existing_report');
const REQUEST_FORCE_REPORT_URL = config.get('insights_api','request_force_report');
const REQUEST_NEW_FORCE_REPORT_URL = config.get('insights_api','request_new_force_report');

async function requestReport (accessToken, username, data,isBLSKpi) {
  try {
    const requestReportResponse = await axios({
      method: 'post',
      responseType: 'json',
      url: isBLSKpi ? REQUEST_FORCE_REPORT_URL : REQUEST_REPORT_URL,
      data: data,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return requestReportResponse;
  } catch (error) {
    throw error.response;
  }
}

async function requestNewReport(accessToken, username, data, isBLSKpi) {
  try {
    const requestNewReportResponse = await axios({
      method: 'post',
      responseType: 'json',
      url: isBLSKpi ? REQUEST_NEW_FORCE_REPORT_URL :  REQUEST_NEW_REPORT_URL,
      data: data,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return requestNewReportResponse;
  } catch (error) {
    throw error.response;
  }
}

async function addExistingReport(accessToken, username, data) {
  try {
    const addExistingReportResponse = await axios({
      method: 'post',
      responseType: 'json',
      url: ADD_EXISTING_REPORT_URL,
      data: data,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return addExistingReportResponse;
  } catch (error) {
    throw error.response;
  }
}

async function requestForceReport(accessToken, username, data) {
  try {
    const requestReportResponse = await axios({
      method: 'post',
      responseType: 'json',
      url: REQUEST_FORCE_REPORT_URL,
      data: data,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return requestReportResponse;
  } catch (error) {
    throw error.response;
  }
}

async function requestNewForceReport(accessToken, username, data) {
  try {
    const requestReportResponse = await axios({
      method: 'post',
      responseType: 'json',
      url: REQUEST_NEW_FORCE_REPORT_URL,
      data: data,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return requestReportResponse;
  } catch (error) {
    throw error.response;
  }
}



export {
  requestReport,
  requestNewReport,
  addExistingReport,
  requestForceReport,
  requestNewForceReport
}
